/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.YXXGame = (function() {

    /**
     * Namespace YXXGame.
     * @exports YXXGame
     * @namespace
     */
    var YXXGame = {};

    YXXGame.Bet = (function() {

        /**
         * Properties of a Bet.
         * @memberof YXXGame
         * @interface IBet
         * @property {number} type Bet type
         * @property {number|null} [count] Bet count
         */

        /**
         * Constructs a new Bet.
         * @memberof YXXGame
         * @classdesc Represents a Bet.
         * @implements IBet
         * @constructor
         * @param {YXXGame.IBet=} [properties] Properties to set
         */
        function Bet(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Bet type.
         * @member {number} type
         * @memberof YXXGame.Bet
         * @instance
         */
        Bet.prototype.type = 0;

        /**
         * Bet count.
         * @member {number} count
         * @memberof YXXGame.Bet
         * @instance
         */
        Bet.prototype.count = 0;

        /**
         * Creates a new Bet instance using the specified properties.
         * @function create
         * @memberof YXXGame.Bet
         * @static
         * @param {YXXGame.IBet=} [properties] Properties to set
         * @returns {YXXGame.Bet} Bet instance
         */
        Bet.create = function create(properties) {
            return new Bet(properties);
        };

        /**
         * Encodes the specified Bet message. Does not implicitly {@link YXXGame.Bet.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.Bet
         * @static
         * @param {YXXGame.IBet} message Bet message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Bet.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.type);
            if (message.count != null && message.hasOwnProperty("count"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.count);
            return writer;
        };

        /**
         * Encodes the specified Bet message, length delimited. Does not implicitly {@link YXXGame.Bet.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.Bet
         * @static
         * @param {YXXGame.IBet} message Bet message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Bet.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Bet message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.Bet
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.Bet} Bet
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Bet.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.Bet();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.double();
                    break;
                case 2:
                    message.count = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a Bet message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.Bet
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.Bet} Bet
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Bet.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Bet message.
         * @function verify
         * @memberof YXXGame.Bet
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Bet.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.type !== "number")
                return "type: number expected";
            if (message.count != null && message.hasOwnProperty("count"))
                if (!$util.isInteger(message.count))
                    return "count: integer expected";
            return null;
        };

        /**
         * Creates a Bet message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.Bet
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.Bet} Bet
         */
        Bet.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.Bet)
                return object;
            var message = new $root.YXXGame.Bet();
            if (object.type != null)
                message.type = Number(object.type);
            if (object.count != null)
                message.count = object.count | 0;
            return message;
        };

        /**
         * Creates a plain object from a Bet message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.Bet
         * @static
         * @param {YXXGame.Bet} message Bet
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Bet.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.count = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.json && !isFinite(message.type) ? String(message.type) : message.type;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            return object;
        };

        /**
         * Converts this Bet to JSON.
         * @function toJSON
         * @memberof YXXGame.Bet
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Bet.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Bet;
    })();

    YXXGame.BetData = (function() {

        /**
         * Properties of a BetData.
         * @memberof YXXGame
         * @interface IBetData
         * @property {number} area BetData area
         * @property {Array.<YXXGame.IBet>|null} [data] BetData data
         * @property {number|null} [amount] BetData amount
         */

        /**
         * Constructs a new BetData.
         * @memberof YXXGame
         * @classdesc Represents a BetData.
         * @implements IBetData
         * @constructor
         * @param {YXXGame.IBetData=} [properties] Properties to set
         */
        function BetData(properties) {
            this.data = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetData area.
         * @member {number} area
         * @memberof YXXGame.BetData
         * @instance
         */
        BetData.prototype.area = 0;

        /**
         * BetData data.
         * @member {Array.<YXXGame.IBet>} data
         * @memberof YXXGame.BetData
         * @instance
         */
        BetData.prototype.data = $util.emptyArray;

        /**
         * BetData amount.
         * @member {number} amount
         * @memberof YXXGame.BetData
         * @instance
         */
        BetData.prototype.amount = 0;

        /**
         * Creates a new BetData instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetData
         * @static
         * @param {YXXGame.IBetData=} [properties] Properties to set
         * @returns {YXXGame.BetData} BetData instance
         */
        BetData.create = function create(properties) {
            return new BetData(properties);
        };

        /**
         * Encodes the specified BetData message. Does not implicitly {@link YXXGame.BetData.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetData
         * @static
         * @param {YXXGame.IBetData} message BetData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.area);
            if (message.data != null && message.data.length)
                for (var i = 0; i < message.data.length; ++i)
                    $root.YXXGame.Bet.encode(message.data[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.amount != null && message.hasOwnProperty("amount"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.amount);
            return writer;
        };

        /**
         * Encodes the specified BetData message, length delimited. Does not implicitly {@link YXXGame.BetData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetData
         * @static
         * @param {YXXGame.IBetData} message BetData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetData message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetData} BetData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.area = reader.int32();
                    break;
                case 2:
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push($root.YXXGame.Bet.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.amount = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("area"))
                throw $util.ProtocolError("missing required 'area'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetData} BetData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetData message.
         * @function verify
         * @memberof YXXGame.BetData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.area))
                return "area: integer expected";
            if (message.data != null && message.hasOwnProperty("data")) {
                if (!Array.isArray(message.data))
                    return "data: array expected";
                for (var i = 0; i < message.data.length; ++i) {
                    var error = $root.YXXGame.Bet.verify(message.data[i]);
                    if (error)
                        return "data." + error;
                }
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount !== "number")
                    return "amount: number expected";
            return null;
        };

        /**
         * Creates a BetData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetData} BetData
         */
        BetData.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetData)
                return object;
            var message = new $root.YXXGame.BetData();
            if (object.area != null)
                message.area = object.area | 0;
            if (object.data) {
                if (!Array.isArray(object.data))
                    throw TypeError(".YXXGame.BetData.data: array expected");
                message.data = [];
                for (var i = 0; i < object.data.length; ++i) {
                    if (typeof object.data[i] !== "object")
                        throw TypeError(".YXXGame.BetData.data: object expected");
                    message.data[i] = $root.YXXGame.Bet.fromObject(object.data[i]);
                }
            }
            if (object.amount != null)
                message.amount = Number(object.amount);
            return message;
        };

        /**
         * Creates a plain object from a BetData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetData
         * @static
         * @param {YXXGame.BetData} message BetData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.data = [];
            if (options.defaults) {
                object.area = 0;
                object.amount = 0;
            }
            if (message.area != null && message.hasOwnProperty("area"))
                object.area = message.area;
            if (message.data && message.data.length) {
                object.data = [];
                for (var j = 0; j < message.data.length; ++j)
                    object.data[j] = $root.YXXGame.Bet.toObject(message.data[j], options);
            }
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
            return object;
        };

        /**
         * Converts this BetData to JSON.
         * @function toJSON
         * @memberof YXXGame.BetData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetData;
    })();

    YXXGame.BetReq = (function() {

        /**
         * Properties of a BetReq.
         * @memberof YXXGame
         * @interface IBetReq
         * @property {number} area BetReq area
         * @property {number} type BetReq type
         */

        /**
         * Constructs a new BetReq.
         * @memberof YXXGame
         * @classdesc Represents a BetReq.
         * @implements IBetReq
         * @constructor
         * @param {YXXGame.IBetReq=} [properties] Properties to set
         */
        function BetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetReq area.
         * @member {number} area
         * @memberof YXXGame.BetReq
         * @instance
         */
        BetReq.prototype.area = 0;

        /**
         * BetReq type.
         * @member {number} type
         * @memberof YXXGame.BetReq
         * @instance
         */
        BetReq.prototype.type = 0;

        /**
         * Creates a new BetReq instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetReq
         * @static
         * @param {YXXGame.IBetReq=} [properties] Properties to set
         * @returns {YXXGame.BetReq} BetReq instance
         */
        BetReq.create = function create(properties) {
            return new BetReq(properties);
        };

        /**
         * Encodes the specified BetReq message. Does not implicitly {@link YXXGame.BetReq.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetReq
         * @static
         * @param {YXXGame.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.area);
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.type);
            return writer;
        };

        /**
         * Encodes the specified BetReq message, length delimited. Does not implicitly {@link YXXGame.BetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetReq
         * @static
         * @param {YXXGame.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.area = reader.int32();
                    break;
                case 2:
                    message.type = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("area"))
                throw $util.ProtocolError("missing required 'area'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetReq message.
         * @function verify
         * @memberof YXXGame.BetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.area))
                return "area: integer expected";
            if (typeof message.type !== "number")
                return "type: number expected";
            return null;
        };

        /**
         * Creates a BetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetReq} BetReq
         */
        BetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetReq)
                return object;
            var message = new $root.YXXGame.BetReq();
            if (object.area != null)
                message.area = object.area | 0;
            if (object.type != null)
                message.type = Number(object.type);
            return message;
        };

        /**
         * Creates a plain object from a BetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetReq
         * @static
         * @param {YXXGame.BetReq} message BetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.area = 0;
                object.type = 0;
            }
            if (message.area != null && message.hasOwnProperty("area"))
                object.area = message.area;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.json && !isFinite(message.type) ? String(message.type) : message.type;
            return object;
        };

        /**
         * Converts this BetReq to JSON.
         * @function toJSON
         * @memberof YXXGame.BetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetReq;
    })();

    YXXGame.BetRsp = (function() {

        /**
         * Properties of a BetRsp.
         * @memberof YXXGame
         * @interface IBetRsp
         * @property {number} errorCode BetRsp errorCode
         * @property {string|null} [errorInfo] BetRsp errorInfo
         */

        /**
         * Constructs a new BetRsp.
         * @memberof YXXGame
         * @classdesc Represents a BetRsp.
         * @implements IBetRsp
         * @constructor
         * @param {YXXGame.IBetRsp=} [properties] Properties to set
         */
        function BetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetRsp errorCode.
         * @member {number} errorCode
         * @memberof YXXGame.BetRsp
         * @instance
         */
        BetRsp.prototype.errorCode = 0;

        /**
         * BetRsp errorInfo.
         * @member {string} errorInfo
         * @memberof YXXGame.BetRsp
         * @instance
         */
        BetRsp.prototype.errorInfo = "";

        /**
         * Creates a new BetRsp instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetRsp
         * @static
         * @param {YXXGame.IBetRsp=} [properties] Properties to set
         * @returns {YXXGame.BetRsp} BetRsp instance
         */
        BetRsp.create = function create(properties) {
            return new BetRsp(properties);
        };

        /**
         * Encodes the specified BetRsp message. Does not implicitly {@link YXXGame.BetRsp.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetRsp
         * @static
         * @param {YXXGame.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorCode);
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorInfo);
            return writer;
        };

        /**
         * Encodes the specified BetRsp message, length delimited. Does not implicitly {@link YXXGame.BetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetRsp
         * @static
         * @param {YXXGame.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errorCode = reader.int32();
                    break;
                case 2:
                    message.errorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errorCode"))
                throw $util.ProtocolError("missing required 'errorCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetRsp message.
         * @function verify
         * @memberof YXXGame.BetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errorCode))
                return "errorCode: integer expected";
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                if (!$util.isString(message.errorInfo))
                    return "errorInfo: string expected";
            return null;
        };

        /**
         * Creates a BetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetRsp} BetRsp
         */
        BetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetRsp)
                return object;
            var message = new $root.YXXGame.BetRsp();
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            if (object.errorInfo != null)
                message.errorInfo = String(object.errorInfo);
            return message;
        };

        /**
         * Creates a plain object from a BetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetRsp
         * @static
         * @param {YXXGame.BetRsp} message BetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errorCode = 0;
                object.errorInfo = "";
            }
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                object.errorInfo = message.errorInfo;
            return object;
        };

        /**
         * Converts this BetRsp to JSON.
         * @function toJSON
         * @memberof YXXGame.BetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetRsp;
    })();

    YXXGame.BetBroadCast = (function() {

        /**
         * Properties of a BetBroadCast.
         * @memberof YXXGame
         * @interface IBetBroadCast
         * @property {Array.<YXXGame.IBetData>|null} [totalData] BetBroadCast totalData
         * @property {Array.<YXXGame.IBetData>|null} [newData] BetBroadCast newData
         * @property {Array.<YXXGame.BetBroadCast.IPlayerBet>|null} [playersBetData] BetBroadCast playersBetData
         * @property {YXXGame.BetBroadCast.IPlayerBet|null} [selfTotalBetData] BetBroadCast selfTotalBetData
         */

        /**
         * Constructs a new BetBroadCast.
         * @memberof YXXGame
         * @classdesc Represents a BetBroadCast.
         * @implements IBetBroadCast
         * @constructor
         * @param {YXXGame.IBetBroadCast=} [properties] Properties to set
         */
        function BetBroadCast(properties) {
            this.totalData = [];
            this.newData = [];
            this.playersBetData = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetBroadCast totalData.
         * @member {Array.<YXXGame.IBetData>} totalData
         * @memberof YXXGame.BetBroadCast
         * @instance
         */
        BetBroadCast.prototype.totalData = $util.emptyArray;

        /**
         * BetBroadCast newData.
         * @member {Array.<YXXGame.IBetData>} newData
         * @memberof YXXGame.BetBroadCast
         * @instance
         */
        BetBroadCast.prototype.newData = $util.emptyArray;

        /**
         * BetBroadCast playersBetData.
         * @member {Array.<YXXGame.BetBroadCast.IPlayerBet>} playersBetData
         * @memberof YXXGame.BetBroadCast
         * @instance
         */
        BetBroadCast.prototype.playersBetData = $util.emptyArray;

        /**
         * BetBroadCast selfTotalBetData.
         * @member {YXXGame.BetBroadCast.IPlayerBet|null|undefined} selfTotalBetData
         * @memberof YXXGame.BetBroadCast
         * @instance
         */
        BetBroadCast.prototype.selfTotalBetData = null;

        /**
         * Creates a new BetBroadCast instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {YXXGame.IBetBroadCast=} [properties] Properties to set
         * @returns {YXXGame.BetBroadCast} BetBroadCast instance
         */
        BetBroadCast.create = function create(properties) {
            return new BetBroadCast(properties);
        };

        /**
         * Encodes the specified BetBroadCast message. Does not implicitly {@link YXXGame.BetBroadCast.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {YXXGame.IBetBroadCast} message BetBroadCast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetBroadCast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.totalData != null && message.totalData.length)
                for (var i = 0; i < message.totalData.length; ++i)
                    $root.YXXGame.BetData.encode(message.totalData[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.newData != null && message.newData.length)
                for (var i = 0; i < message.newData.length; ++i)
                    $root.YXXGame.BetData.encode(message.newData[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.playersBetData != null && message.playersBetData.length)
                for (var i = 0; i < message.playersBetData.length; ++i)
                    $root.YXXGame.BetBroadCast.PlayerBet.encode(message.playersBetData[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.selfTotalBetData != null && message.hasOwnProperty("selfTotalBetData"))
                $root.YXXGame.BetBroadCast.PlayerBet.encode(message.selfTotalBetData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BetBroadCast message, length delimited. Does not implicitly {@link YXXGame.BetBroadCast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {YXXGame.IBetBroadCast} message BetBroadCast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetBroadCast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetBroadCast message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetBroadCast} BetBroadCast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetBroadCast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetBroadCast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.totalData && message.totalData.length))
                        message.totalData = [];
                    message.totalData.push($root.YXXGame.BetData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.newData && message.newData.length))
                        message.newData = [];
                    message.newData.push($root.YXXGame.BetData.decode(reader, reader.uint32()));
                    break;
                case 3:
                    if (!(message.playersBetData && message.playersBetData.length))
                        message.playersBetData = [];
                    message.playersBetData.push($root.YXXGame.BetBroadCast.PlayerBet.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.selfTotalBetData = $root.YXXGame.BetBroadCast.PlayerBet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetBroadCast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetBroadCast} BetBroadCast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetBroadCast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetBroadCast message.
         * @function verify
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetBroadCast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.totalData != null && message.hasOwnProperty("totalData")) {
                if (!Array.isArray(message.totalData))
                    return "totalData: array expected";
                for (var i = 0; i < message.totalData.length; ++i) {
                    var error = $root.YXXGame.BetData.verify(message.totalData[i]);
                    if (error)
                        return "totalData." + error;
                }
            }
            if (message.newData != null && message.hasOwnProperty("newData")) {
                if (!Array.isArray(message.newData))
                    return "newData: array expected";
                for (var i = 0; i < message.newData.length; ++i) {
                    var error = $root.YXXGame.BetData.verify(message.newData[i]);
                    if (error)
                        return "newData." + error;
                }
            }
            if (message.playersBetData != null && message.hasOwnProperty("playersBetData")) {
                if (!Array.isArray(message.playersBetData))
                    return "playersBetData: array expected";
                for (var i = 0; i < message.playersBetData.length; ++i) {
                    var error = $root.YXXGame.BetBroadCast.PlayerBet.verify(message.playersBetData[i]);
                    if (error)
                        return "playersBetData." + error;
                }
            }
            if (message.selfTotalBetData != null && message.hasOwnProperty("selfTotalBetData")) {
                var error = $root.YXXGame.BetBroadCast.PlayerBet.verify(message.selfTotalBetData);
                if (error)
                    return "selfTotalBetData." + error;
            }
            return null;
        };

        /**
         * Creates a BetBroadCast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetBroadCast} BetBroadCast
         */
        BetBroadCast.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetBroadCast)
                return object;
            var message = new $root.YXXGame.BetBroadCast();
            if (object.totalData) {
                if (!Array.isArray(object.totalData))
                    throw TypeError(".YXXGame.BetBroadCast.totalData: array expected");
                message.totalData = [];
                for (var i = 0; i < object.totalData.length; ++i) {
                    if (typeof object.totalData[i] !== "object")
                        throw TypeError(".YXXGame.BetBroadCast.totalData: object expected");
                    message.totalData[i] = $root.YXXGame.BetData.fromObject(object.totalData[i]);
                }
            }
            if (object.newData) {
                if (!Array.isArray(object.newData))
                    throw TypeError(".YXXGame.BetBroadCast.newData: array expected");
                message.newData = [];
                for (var i = 0; i < object.newData.length; ++i) {
                    if (typeof object.newData[i] !== "object")
                        throw TypeError(".YXXGame.BetBroadCast.newData: object expected");
                    message.newData[i] = $root.YXXGame.BetData.fromObject(object.newData[i]);
                }
            }
            if (object.playersBetData) {
                if (!Array.isArray(object.playersBetData))
                    throw TypeError(".YXXGame.BetBroadCast.playersBetData: array expected");
                message.playersBetData = [];
                for (var i = 0; i < object.playersBetData.length; ++i) {
                    if (typeof object.playersBetData[i] !== "object")
                        throw TypeError(".YXXGame.BetBroadCast.playersBetData: object expected");
                    message.playersBetData[i] = $root.YXXGame.BetBroadCast.PlayerBet.fromObject(object.playersBetData[i]);
                }
            }
            if (object.selfTotalBetData != null) {
                if (typeof object.selfTotalBetData !== "object")
                    throw TypeError(".YXXGame.BetBroadCast.selfTotalBetData: object expected");
                message.selfTotalBetData = $root.YXXGame.BetBroadCast.PlayerBet.fromObject(object.selfTotalBetData);
            }
            return message;
        };

        /**
         * Creates a plain object from a BetBroadCast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetBroadCast
         * @static
         * @param {YXXGame.BetBroadCast} message BetBroadCast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetBroadCast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.totalData = [];
                object.newData = [];
                object.playersBetData = [];
            }
            if (options.defaults)
                object.selfTotalBetData = null;
            if (message.totalData && message.totalData.length) {
                object.totalData = [];
                for (var j = 0; j < message.totalData.length; ++j)
                    object.totalData[j] = $root.YXXGame.BetData.toObject(message.totalData[j], options);
            }
            if (message.newData && message.newData.length) {
                object.newData = [];
                for (var j = 0; j < message.newData.length; ++j)
                    object.newData[j] = $root.YXXGame.BetData.toObject(message.newData[j], options);
            }
            if (message.playersBetData && message.playersBetData.length) {
                object.playersBetData = [];
                for (var j = 0; j < message.playersBetData.length; ++j)
                    object.playersBetData[j] = $root.YXXGame.BetBroadCast.PlayerBet.toObject(message.playersBetData[j], options);
            }
            if (message.selfTotalBetData != null && message.hasOwnProperty("selfTotalBetData"))
                object.selfTotalBetData = $root.YXXGame.BetBroadCast.PlayerBet.toObject(message.selfTotalBetData, options);
            return object;
        };

        /**
         * Converts this BetBroadCast to JSON.
         * @function toJSON
         * @memberof YXXGame.BetBroadCast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetBroadCast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        BetBroadCast.PlayerBet = (function() {

            /**
             * Properties of a PlayerBet.
             * @memberof YXXGame.BetBroadCast
             * @interface IPlayerBet
             * @property {string} id PlayerBet id
             * @property {Array.<YXXGame.IBetData>|null} [data] PlayerBet data
             */

            /**
             * Constructs a new PlayerBet.
             * @memberof YXXGame.BetBroadCast
             * @classdesc Represents a PlayerBet.
             * @implements IPlayerBet
             * @constructor
             * @param {YXXGame.BetBroadCast.IPlayerBet=} [properties] Properties to set
             */
            function PlayerBet(properties) {
                this.data = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PlayerBet id.
             * @member {string} id
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @instance
             */
            PlayerBet.prototype.id = "";

            /**
             * PlayerBet data.
             * @member {Array.<YXXGame.IBetData>} data
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @instance
             */
            PlayerBet.prototype.data = $util.emptyArray;

            /**
             * Creates a new PlayerBet instance using the specified properties.
             * @function create
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {YXXGame.BetBroadCast.IPlayerBet=} [properties] Properties to set
             * @returns {YXXGame.BetBroadCast.PlayerBet} PlayerBet instance
             */
            PlayerBet.create = function create(properties) {
                return new PlayerBet(properties);
            };

            /**
             * Encodes the specified PlayerBet message. Does not implicitly {@link YXXGame.BetBroadCast.PlayerBet.verify|verify} messages.
             * @function encode
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {YXXGame.BetBroadCast.IPlayerBet} message PlayerBet message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerBet.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                if (message.data != null && message.data.length)
                    for (var i = 0; i < message.data.length; ++i)
                        $root.YXXGame.BetData.encode(message.data[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified PlayerBet message, length delimited. Does not implicitly {@link YXXGame.BetBroadCast.PlayerBet.verify|verify} messages.
             * @function encodeDelimited
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {YXXGame.BetBroadCast.IPlayerBet} message PlayerBet message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PlayerBet.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PlayerBet message from the specified reader or buffer.
             * @function decode
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {YXXGame.BetBroadCast.PlayerBet} PlayerBet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerBet.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetBroadCast.PlayerBet();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        if (!(message.data && message.data.length))
                            message.data = [];
                        message.data.push($root.YXXGame.BetData.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("id"))
                    throw $util.ProtocolError("missing required 'id'", { instance: message });
                return message;
            };

            /**
             * Decodes a PlayerBet message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {YXXGame.BetBroadCast.PlayerBet} PlayerBet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PlayerBet.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PlayerBet message.
             * @function verify
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PlayerBet.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isString(message.id))
                    return "id: string expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    if (!Array.isArray(message.data))
                        return "data: array expected";
                    for (var i = 0; i < message.data.length; ++i) {
                        var error = $root.YXXGame.BetData.verify(message.data[i]);
                        if (error)
                            return "data." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a PlayerBet message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {YXXGame.BetBroadCast.PlayerBet} PlayerBet
             */
            PlayerBet.fromObject = function fromObject(object) {
                if (object instanceof $root.YXXGame.BetBroadCast.PlayerBet)
                    return object;
                var message = new $root.YXXGame.BetBroadCast.PlayerBet();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.data) {
                    if (!Array.isArray(object.data))
                        throw TypeError(".YXXGame.BetBroadCast.PlayerBet.data: array expected");
                    message.data = [];
                    for (var i = 0; i < object.data.length; ++i) {
                        if (typeof object.data[i] !== "object")
                            throw TypeError(".YXXGame.BetBroadCast.PlayerBet.data: object expected");
                        message.data[i] = $root.YXXGame.BetData.fromObject(object.data[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a PlayerBet message. Also converts values to other types if specified.
             * @function toObject
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @static
             * @param {YXXGame.BetBroadCast.PlayerBet} message PlayerBet
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PlayerBet.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.data = [];
                if (options.defaults)
                    object.id = "";
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.data && message.data.length) {
                    object.data = [];
                    for (var j = 0; j < message.data.length; ++j)
                        object.data[j] = $root.YXXGame.BetData.toObject(message.data[j], options);
                }
                return object;
            };

            /**
             * Converts this PlayerBet to JSON.
             * @function toJSON
             * @memberof YXXGame.BetBroadCast.PlayerBet
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PlayerBet.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PlayerBet;
        })();

        return BetBroadCast;
    })();

    YXXGame.Dice = (function() {

        /**
         * Properties of a Dice.
         * @memberof YXXGame
         * @interface IDice
         * @property {number} color Dice color
         * @property {number} number Dice number
         */

        /**
         * Constructs a new Dice.
         * @memberof YXXGame
         * @classdesc Represents a Dice.
         * @implements IDice
         * @constructor
         * @param {YXXGame.IDice=} [properties] Properties to set
         */
        function Dice(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Dice color.
         * @member {number} color
         * @memberof YXXGame.Dice
         * @instance
         */
        Dice.prototype.color = 0;

        /**
         * Dice number.
         * @member {number} number
         * @memberof YXXGame.Dice
         * @instance
         */
        Dice.prototype.number = 0;

        /**
         * Creates a new Dice instance using the specified properties.
         * @function create
         * @memberof YXXGame.Dice
         * @static
         * @param {YXXGame.IDice=} [properties] Properties to set
         * @returns {YXXGame.Dice} Dice instance
         */
        Dice.create = function create(properties) {
            return new Dice(properties);
        };

        /**
         * Encodes the specified Dice message. Does not implicitly {@link YXXGame.Dice.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.Dice
         * @static
         * @param {YXXGame.IDice} message Dice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Dice.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.color);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.number);
            return writer;
        };

        /**
         * Encodes the specified Dice message, length delimited. Does not implicitly {@link YXXGame.Dice.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.Dice
         * @static
         * @param {YXXGame.IDice} message Dice message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Dice.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Dice message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.Dice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.Dice} Dice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Dice.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.Dice();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.color = reader.int32();
                    break;
                case 2:
                    message.number = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("color"))
                throw $util.ProtocolError("missing required 'color'", { instance: message });
            if (!message.hasOwnProperty("number"))
                throw $util.ProtocolError("missing required 'number'", { instance: message });
            return message;
        };

        /**
         * Decodes a Dice message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.Dice
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.Dice} Dice
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Dice.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Dice message.
         * @function verify
         * @memberof YXXGame.Dice
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Dice.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.color))
                return "color: integer expected";
            if (!$util.isInteger(message.number))
                return "number: integer expected";
            return null;
        };

        /**
         * Creates a Dice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.Dice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.Dice} Dice
         */
        Dice.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.Dice)
                return object;
            var message = new $root.YXXGame.Dice();
            if (object.color != null)
                message.color = object.color | 0;
            if (object.number != null)
                message.number = object.number | 0;
            return message;
        };

        /**
         * Creates a plain object from a Dice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.Dice
         * @static
         * @param {YXXGame.Dice} message Dice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Dice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.color = 0;
                object.number = 0;
            }
            if (message.color != null && message.hasOwnProperty("color"))
                object.color = message.color;
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            return object;
        };

        /**
         * Converts this Dice to JSON.
         * @function toJSON
         * @memberof YXXGame.Dice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Dice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Dice;
    })();

    YXXGame.BetResult = (function() {

        /**
         * Properties of a BetResult.
         * @memberof YXXGame
         * @interface IBetResult
         * @property {Array.<YXXGame.IDice>|null} [dice] BetResult dice
         * @property {number} result BetResult result
         */

        /**
         * Constructs a new BetResult.
         * @memberof YXXGame
         * @classdesc Represents a BetResult.
         * @implements IBetResult
         * @constructor
         * @param {YXXGame.IBetResult=} [properties] Properties to set
         */
        function BetResult(properties) {
            this.dice = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetResult dice.
         * @member {Array.<YXXGame.IDice>} dice
         * @memberof YXXGame.BetResult
         * @instance
         */
        BetResult.prototype.dice = $util.emptyArray;

        /**
         * BetResult result.
         * @member {number} result
         * @memberof YXXGame.BetResult
         * @instance
         */
        BetResult.prototype.result = 0;

        /**
         * Creates a new BetResult instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetResult
         * @static
         * @param {YXXGame.IBetResult=} [properties] Properties to set
         * @returns {YXXGame.BetResult} BetResult instance
         */
        BetResult.create = function create(properties) {
            return new BetResult(properties);
        };

        /**
         * Encodes the specified BetResult message. Does not implicitly {@link YXXGame.BetResult.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetResult
         * @static
         * @param {YXXGame.IBetResult} message BetResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dice != null && message.dice.length)
                for (var i = 0; i < message.dice.length; ++i)
                    $root.YXXGame.Dice.encode(message.dice[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.result);
            return writer;
        };

        /**
         * Encodes the specified BetResult message, length delimited. Does not implicitly {@link YXXGame.BetResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetResult
         * @static
         * @param {YXXGame.IBetResult} message BetResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetResult message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetResult} BetResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetResult();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.dice && message.dice.length))
                        message.dice = [];
                    message.dice.push($root.YXXGame.Dice.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("result"))
                throw $util.ProtocolError("missing required 'result'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetResult} BetResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetResult message.
         * @function verify
         * @memberof YXXGame.BetResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dice != null && message.hasOwnProperty("dice")) {
                if (!Array.isArray(message.dice))
                    return "dice: array expected";
                for (var i = 0; i < message.dice.length; ++i) {
                    var error = $root.YXXGame.Dice.verify(message.dice[i]);
                    if (error)
                        return "dice." + error;
                }
            }
            if (!$util.isInteger(message.result))
                return "result: integer expected";
            return null;
        };

        /**
         * Creates a BetResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetResult} BetResult
         */
        BetResult.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetResult)
                return object;
            var message = new $root.YXXGame.BetResult();
            if (object.dice) {
                if (!Array.isArray(object.dice))
                    throw TypeError(".YXXGame.BetResult.dice: array expected");
                message.dice = [];
                for (var i = 0; i < object.dice.length; ++i) {
                    if (typeof object.dice[i] !== "object")
                        throw TypeError(".YXXGame.BetResult.dice: object expected");
                    message.dice[i] = $root.YXXGame.Dice.fromObject(object.dice[i]);
                }
            }
            if (object.result != null)
                message.result = object.result | 0;
            return message;
        };

        /**
         * Creates a plain object from a BetResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetResult
         * @static
         * @param {YXXGame.BetResult} message BetResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.dice = [];
            if (options.defaults)
                object.result = 0;
            if (message.dice && message.dice.length) {
                object.dice = [];
                for (var j = 0; j < message.dice.length; ++j)
                    object.dice[j] = $root.YXXGame.Dice.toObject(message.dice[j], options);
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this BetResult to JSON.
         * @function toJSON
         * @memberof YXXGame.BetResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetResult;
    })();

    YXXGame.BetResultHistory = (function() {

        /**
         * Properties of a BetResultHistory.
         * @memberof YXXGame
         * @interface IBetResultHistory
         * @property {Array.<number>|null} [result] BetResultHistory result
         */

        /**
         * Constructs a new BetResultHistory.
         * @memberof YXXGame
         * @classdesc Represents a BetResultHistory.
         * @implements IBetResultHistory
         * @constructor
         * @param {YXXGame.IBetResultHistory=} [properties] Properties to set
         */
        function BetResultHistory(properties) {
            this.result = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetResultHistory result.
         * @member {Array.<number>} result
         * @memberof YXXGame.BetResultHistory
         * @instance
         */
        BetResultHistory.prototype.result = $util.emptyArray;

        /**
         * Creates a new BetResultHistory instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {YXXGame.IBetResultHistory=} [properties] Properties to set
         * @returns {YXXGame.BetResultHistory} BetResultHistory instance
         */
        BetResultHistory.create = function create(properties) {
            return new BetResultHistory(properties);
        };

        /**
         * Encodes the specified BetResultHistory message. Does not implicitly {@link YXXGame.BetResultHistory.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {YXXGame.IBetResultHistory} message BetResultHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && message.result.length)
                for (var i = 0; i < message.result.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.result[i]);
            return writer;
        };

        /**
         * Encodes the specified BetResultHistory message, length delimited. Does not implicitly {@link YXXGame.BetResultHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {YXXGame.IBetResultHistory} message BetResultHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetResultHistory message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetResultHistory} BetResultHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultHistory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetResultHistory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.result && message.result.length))
                        message.result = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.result.push(reader.int32());
                    } else
                        message.result.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetResultHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetResultHistory} BetResultHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetResultHistory message.
         * @function verify
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetResultHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.result != null && message.hasOwnProperty("result")) {
                if (!Array.isArray(message.result))
                    return "result: array expected";
                for (var i = 0; i < message.result.length; ++i)
                    if (!$util.isInteger(message.result[i]))
                        return "result: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a BetResultHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetResultHistory} BetResultHistory
         */
        BetResultHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetResultHistory)
                return object;
            var message = new $root.YXXGame.BetResultHistory();
            if (object.result) {
                if (!Array.isArray(object.result))
                    throw TypeError(".YXXGame.BetResultHistory.result: array expected");
                message.result = [];
                for (var i = 0; i < object.result.length; ++i)
                    message.result[i] = object.result[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a BetResultHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetResultHistory
         * @static
         * @param {YXXGame.BetResultHistory} message BetResultHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetResultHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.result = [];
            if (message.result && message.result.length) {
                object.result = [];
                for (var j = 0; j < message.result.length; ++j)
                    object.result[j] = message.result[j];
            }
            return object;
        };

        /**
         * Converts this BetResultHistory to JSON.
         * @function toJSON
         * @memberof YXXGame.BetResultHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetResultHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetResultHistory;
    })();

    YXXGame.BetResultDetailReq = (function() {

        /**
         * Properties of a BetResultDetailReq.
         * @memberof YXXGame
         * @interface IBetResultDetailReq
         */

        /**
         * Constructs a new BetResultDetailReq.
         * @memberof YXXGame
         * @classdesc Represents a BetResultDetailReq.
         * @implements IBetResultDetailReq
         * @constructor
         * @param {YXXGame.IBetResultDetailReq=} [properties] Properties to set
         */
        function BetResultDetailReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new BetResultDetailReq instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {YXXGame.IBetResultDetailReq=} [properties] Properties to set
         * @returns {YXXGame.BetResultDetailReq} BetResultDetailReq instance
         */
        BetResultDetailReq.create = function create(properties) {
            return new BetResultDetailReq(properties);
        };

        /**
         * Encodes the specified BetResultDetailReq message. Does not implicitly {@link YXXGame.BetResultDetailReq.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {YXXGame.IBetResultDetailReq} message BetResultDetailReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultDetailReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified BetResultDetailReq message, length delimited. Does not implicitly {@link YXXGame.BetResultDetailReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {YXXGame.IBetResultDetailReq} message BetResultDetailReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultDetailReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetResultDetailReq message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetResultDetailReq} BetResultDetailReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultDetailReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetResultDetailReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetResultDetailReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetResultDetailReq} BetResultDetailReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultDetailReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetResultDetailReq message.
         * @function verify
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetResultDetailReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a BetResultDetailReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetResultDetailReq} BetResultDetailReq
         */
        BetResultDetailReq.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetResultDetailReq)
                return object;
            return new $root.YXXGame.BetResultDetailReq();
        };

        /**
         * Creates a plain object from a BetResultDetailReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetResultDetailReq
         * @static
         * @param {YXXGame.BetResultDetailReq} message BetResultDetailReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetResultDetailReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this BetResultDetailReq to JSON.
         * @function toJSON
         * @memberof YXXGame.BetResultDetailReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetResultDetailReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetResultDetailReq;
    })();

    YXXGame.BetResultDetailRsp = (function() {

        /**
         * Properties of a BetResultDetailRsp.
         * @memberof YXXGame
         * @interface IBetResultDetailRsp
         * @property {Array.<YXXGame.IBetResult>|null} [results] BetResultDetailRsp results
         */

        /**
         * Constructs a new BetResultDetailRsp.
         * @memberof YXXGame
         * @classdesc Represents a BetResultDetailRsp.
         * @implements IBetResultDetailRsp
         * @constructor
         * @param {YXXGame.IBetResultDetailRsp=} [properties] Properties to set
         */
        function BetResultDetailRsp(properties) {
            this.results = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetResultDetailRsp results.
         * @member {Array.<YXXGame.IBetResult>} results
         * @memberof YXXGame.BetResultDetailRsp
         * @instance
         */
        BetResultDetailRsp.prototype.results = $util.emptyArray;

        /**
         * Creates a new BetResultDetailRsp instance using the specified properties.
         * @function create
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {YXXGame.IBetResultDetailRsp=} [properties] Properties to set
         * @returns {YXXGame.BetResultDetailRsp} BetResultDetailRsp instance
         */
        BetResultDetailRsp.create = function create(properties) {
            return new BetResultDetailRsp(properties);
        };

        /**
         * Encodes the specified BetResultDetailRsp message. Does not implicitly {@link YXXGame.BetResultDetailRsp.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {YXXGame.IBetResultDetailRsp} message BetResultDetailRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultDetailRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.results != null && message.results.length)
                for (var i = 0; i < message.results.length; ++i)
                    $root.YXXGame.BetResult.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BetResultDetailRsp message, length delimited. Does not implicitly {@link YXXGame.BetResultDetailRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {YXXGame.IBetResultDetailRsp} message BetResultDetailRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetResultDetailRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetResultDetailRsp message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BetResultDetailRsp} BetResultDetailRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultDetailRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BetResultDetailRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.results && message.results.length))
                        message.results = [];
                    message.results.push($root.YXXGame.BetResult.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetResultDetailRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BetResultDetailRsp} BetResultDetailRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetResultDetailRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetResultDetailRsp message.
         * @function verify
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetResultDetailRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.results != null && message.hasOwnProperty("results")) {
                if (!Array.isArray(message.results))
                    return "results: array expected";
                for (var i = 0; i < message.results.length; ++i) {
                    var error = $root.YXXGame.BetResult.verify(message.results[i]);
                    if (error)
                        return "results." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BetResultDetailRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BetResultDetailRsp} BetResultDetailRsp
         */
        BetResultDetailRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BetResultDetailRsp)
                return object;
            var message = new $root.YXXGame.BetResultDetailRsp();
            if (object.results) {
                if (!Array.isArray(object.results))
                    throw TypeError(".YXXGame.BetResultDetailRsp.results: array expected");
                message.results = [];
                for (var i = 0; i < object.results.length; ++i) {
                    if (typeof object.results[i] !== "object")
                        throw TypeError(".YXXGame.BetResultDetailRsp.results: object expected");
                    message.results[i] = $root.YXXGame.BetResult.fromObject(object.results[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BetResultDetailRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BetResultDetailRsp
         * @static
         * @param {YXXGame.BetResultDetailRsp} message BetResultDetailRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetResultDetailRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.results = [];
            if (message.results && message.results.length) {
                object.results = [];
                for (var j = 0; j < message.results.length; ++j)
                    object.results[j] = $root.YXXGame.BetResult.toObject(message.results[j], options);
            }
            return object;
        };

        /**
         * Converts this BetResultDetailRsp to JSON.
         * @function toJSON
         * @memberof YXXGame.BetResultDetailRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetResultDetailRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetResultDetailRsp;
    })();

    YXXGame.OnlinePlayersReq = (function() {

        /**
         * Properties of an OnlinePlayersReq.
         * @memberof YXXGame
         * @interface IOnlinePlayersReq
         */

        /**
         * Constructs a new OnlinePlayersReq.
         * @memberof YXXGame
         * @classdesc Represents an OnlinePlayersReq.
         * @implements IOnlinePlayersReq
         * @constructor
         * @param {YXXGame.IOnlinePlayersReq=} [properties] Properties to set
         */
        function OnlinePlayersReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OnlinePlayersReq instance using the specified properties.
         * @function create
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {YXXGame.IOnlinePlayersReq=} [properties] Properties to set
         * @returns {YXXGame.OnlinePlayersReq} OnlinePlayersReq instance
         */
        OnlinePlayersReq.create = function create(properties) {
            return new OnlinePlayersReq(properties);
        };

        /**
         * Encodes the specified OnlinePlayersReq message. Does not implicitly {@link YXXGame.OnlinePlayersReq.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {YXXGame.IOnlinePlayersReq} message OnlinePlayersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlinePlayersReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OnlinePlayersReq message, length delimited. Does not implicitly {@link YXXGame.OnlinePlayersReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {YXXGame.IOnlinePlayersReq} message OnlinePlayersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlinePlayersReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnlinePlayersReq message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.OnlinePlayersReq} OnlinePlayersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlinePlayersReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.OnlinePlayersReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OnlinePlayersReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.OnlinePlayersReq} OnlinePlayersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlinePlayersReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnlinePlayersReq message.
         * @function verify
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnlinePlayersReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OnlinePlayersReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.OnlinePlayersReq} OnlinePlayersReq
         */
        OnlinePlayersReq.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.OnlinePlayersReq)
                return object;
            return new $root.YXXGame.OnlinePlayersReq();
        };

        /**
         * Creates a plain object from an OnlinePlayersReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.OnlinePlayersReq
         * @static
         * @param {YXXGame.OnlinePlayersReq} message OnlinePlayersReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnlinePlayersReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OnlinePlayersReq to JSON.
         * @function toJSON
         * @memberof YXXGame.OnlinePlayersReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnlinePlayersReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OnlinePlayersReq;
    })();

    YXXGame.OnlinePlayersRsp = (function() {

        /**
         * Properties of an OnlinePlayersRsp.
         * @memberof YXXGame
         * @interface IOnlinePlayersRsp
         * @property {Array.<YXXGame.OnlinePlayersRsp.IPlayer>|null} [players] OnlinePlayersRsp players
         * @property {number} roundsCnt OnlinePlayersRsp roundsCnt
         */

        /**
         * Constructs a new OnlinePlayersRsp.
         * @memberof YXXGame
         * @classdesc Represents an OnlinePlayersRsp.
         * @implements IOnlinePlayersRsp
         * @constructor
         * @param {YXXGame.IOnlinePlayersRsp=} [properties] Properties to set
         */
        function OnlinePlayersRsp(properties) {
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OnlinePlayersRsp players.
         * @member {Array.<YXXGame.OnlinePlayersRsp.IPlayer>} players
         * @memberof YXXGame.OnlinePlayersRsp
         * @instance
         */
        OnlinePlayersRsp.prototype.players = $util.emptyArray;

        /**
         * OnlinePlayersRsp roundsCnt.
         * @member {number} roundsCnt
         * @memberof YXXGame.OnlinePlayersRsp
         * @instance
         */
        OnlinePlayersRsp.prototype.roundsCnt = 0;

        /**
         * Creates a new OnlinePlayersRsp instance using the specified properties.
         * @function create
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {YXXGame.IOnlinePlayersRsp=} [properties] Properties to set
         * @returns {YXXGame.OnlinePlayersRsp} OnlinePlayersRsp instance
         */
        OnlinePlayersRsp.create = function create(properties) {
            return new OnlinePlayersRsp(properties);
        };

        /**
         * Encodes the specified OnlinePlayersRsp message. Does not implicitly {@link YXXGame.OnlinePlayersRsp.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {YXXGame.IOnlinePlayersRsp} message OnlinePlayersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlinePlayersRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.YXXGame.OnlinePlayersRsp.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roundsCnt);
            return writer;
        };

        /**
         * Encodes the specified OnlinePlayersRsp message, length delimited. Does not implicitly {@link YXXGame.OnlinePlayersRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {YXXGame.IOnlinePlayersRsp} message OnlinePlayersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlinePlayersRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnlinePlayersRsp message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.OnlinePlayersRsp} OnlinePlayersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlinePlayersRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.OnlinePlayersRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.YXXGame.OnlinePlayersRsp.Player.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.roundsCnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("roundsCnt"))
                throw $util.ProtocolError("missing required 'roundsCnt'", { instance: message });
            return message;
        };

        /**
         * Decodes an OnlinePlayersRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.OnlinePlayersRsp} OnlinePlayersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlinePlayersRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnlinePlayersRsp message.
         * @function verify
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnlinePlayersRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.YXXGame.OnlinePlayersRsp.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (!$util.isInteger(message.roundsCnt))
                return "roundsCnt: integer expected";
            return null;
        };

        /**
         * Creates an OnlinePlayersRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.OnlinePlayersRsp} OnlinePlayersRsp
         */
        OnlinePlayersRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.OnlinePlayersRsp)
                return object;
            var message = new $root.YXXGame.OnlinePlayersRsp();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".YXXGame.OnlinePlayersRsp.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".YXXGame.OnlinePlayersRsp.players: object expected");
                    message.players[i] = $root.YXXGame.OnlinePlayersRsp.Player.fromObject(object.players[i]);
                }
            }
            if (object.roundsCnt != null)
                message.roundsCnt = object.roundsCnt | 0;
            return message;
        };

        /**
         * Creates a plain object from an OnlinePlayersRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.OnlinePlayersRsp
         * @static
         * @param {YXXGame.OnlinePlayersRsp} message OnlinePlayersRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnlinePlayersRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.players = [];
            if (options.defaults)
                object.roundsCnt = 0;
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.YXXGame.OnlinePlayersRsp.Player.toObject(message.players[j], options);
            }
            if (message.roundsCnt != null && message.hasOwnProperty("roundsCnt"))
                object.roundsCnt = message.roundsCnt;
            return object;
        };

        /**
         * Converts this OnlinePlayersRsp to JSON.
         * @function toJSON
         * @memberof YXXGame.OnlinePlayersRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnlinePlayersRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OnlinePlayersRsp.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof YXXGame.OnlinePlayersRsp
             * @interface IPlayer
             * @property {string} id Player id
             * @property {string} balance Player balance
             * @property {string} betAmount Player betAmount
             * @property {number} winCount Player winCount
             * @property {string} userData Player userData
             */

            /**
             * Constructs a new Player.
             * @memberof YXXGame.OnlinePlayersRsp
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {YXXGame.OnlinePlayersRsp.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player id.
             * @member {string} id
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             */
            Player.prototype.id = "";

            /**
             * Player balance.
             * @member {string} balance
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             */
            Player.prototype.balance = "";

            /**
             * Player betAmount.
             * @member {string} betAmount
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             */
            Player.prototype.betAmount = "";

            /**
             * Player winCount.
             * @member {number} winCount
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             */
            Player.prototype.winCount = 0;

            /**
             * Player userData.
             * @member {string} userData
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             */
            Player.prototype.userData = "";

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {YXXGame.OnlinePlayersRsp.IPlayer=} [properties] Properties to set
             * @returns {YXXGame.OnlinePlayersRsp.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link YXXGame.OnlinePlayersRsp.Player.verify|verify} messages.
             * @function encode
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {YXXGame.OnlinePlayersRsp.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.balance);
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.betAmount);
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.winCount);
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.userData);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link YXXGame.OnlinePlayersRsp.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {YXXGame.OnlinePlayersRsp.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {YXXGame.OnlinePlayersRsp.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.OnlinePlayersRsp.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.string();
                        break;
                    case 2:
                        message.balance = reader.string();
                        break;
                    case 3:
                        message.betAmount = reader.string();
                        break;
                    case 4:
                        message.winCount = reader.int32();
                        break;
                    case 5:
                        message.userData = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("id"))
                    throw $util.ProtocolError("missing required 'id'", { instance: message });
                if (!message.hasOwnProperty("balance"))
                    throw $util.ProtocolError("missing required 'balance'", { instance: message });
                if (!message.hasOwnProperty("betAmount"))
                    throw $util.ProtocolError("missing required 'betAmount'", { instance: message });
                if (!message.hasOwnProperty("winCount"))
                    throw $util.ProtocolError("missing required 'winCount'", { instance: message });
                if (!message.hasOwnProperty("userData"))
                    throw $util.ProtocolError("missing required 'userData'", { instance: message });
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {YXXGame.OnlinePlayersRsp.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isString(message.id))
                    return "id: string expected";
                if (!$util.isString(message.balance))
                    return "balance: string expected";
                if (!$util.isString(message.betAmount))
                    return "betAmount: string expected";
                if (!$util.isInteger(message.winCount))
                    return "winCount: integer expected";
                if (!$util.isString(message.userData))
                    return "userData: string expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {YXXGame.OnlinePlayersRsp.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.YXXGame.OnlinePlayersRsp.Player)
                    return object;
                var message = new $root.YXXGame.OnlinePlayersRsp.Player();
                if (object.id != null)
                    message.id = String(object.id);
                if (object.balance != null)
                    message.balance = String(object.balance);
                if (object.betAmount != null)
                    message.betAmount = String(object.betAmount);
                if (object.winCount != null)
                    message.winCount = object.winCount | 0;
                if (object.userData != null)
                    message.userData = String(object.userData);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @static
             * @param {YXXGame.OnlinePlayersRsp.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = "";
                    object.balance = "";
                    object.betAmount = "";
                    object.winCount = 0;
                    object.userData = "";
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.balance != null && message.hasOwnProperty("balance"))
                    object.balance = message.balance;
                if (message.betAmount != null && message.hasOwnProperty("betAmount"))
                    object.betAmount = message.betAmount;
                if (message.winCount != null && message.hasOwnProperty("winCount"))
                    object.winCount = message.winCount;
                if (message.userData != null && message.hasOwnProperty("userData"))
                    object.userData = message.userData;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof YXXGame.OnlinePlayersRsp.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return OnlinePlayersRsp;
    })();

    YXXGame.BankerReq = (function() {

        /**
         * Properties of a BankerReq.
         * @memberof YXXGame
         * @interface IBankerReq
         * @property {number} type BankerReq type
         */

        /**
         * Constructs a new BankerReq.
         * @memberof YXXGame
         * @classdesc Represents a BankerReq.
         * @implements IBankerReq
         * @constructor
         * @param {YXXGame.IBankerReq=} [properties] Properties to set
         */
        function BankerReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerReq type.
         * @member {number} type
         * @memberof YXXGame.BankerReq
         * @instance
         */
        BankerReq.prototype.type = 0;

        /**
         * Creates a new BankerReq instance using the specified properties.
         * @function create
         * @memberof YXXGame.BankerReq
         * @static
         * @param {YXXGame.IBankerReq=} [properties] Properties to set
         * @returns {YXXGame.BankerReq} BankerReq instance
         */
        BankerReq.create = function create(properties) {
            return new BankerReq(properties);
        };

        /**
         * Encodes the specified BankerReq message. Does not implicitly {@link YXXGame.BankerReq.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BankerReq
         * @static
         * @param {YXXGame.IBankerReq} message BankerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            return writer;
        };

        /**
         * Encodes the specified BankerReq message, length delimited. Does not implicitly {@link YXXGame.BankerReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BankerReq
         * @static
         * @param {YXXGame.IBankerReq} message BankerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerReq message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BankerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BankerReq} BankerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BankerReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a BankerReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BankerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BankerReq} BankerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerReq message.
         * @function verify
         * @memberof YXXGame.BankerReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            return null;
        };

        /**
         * Creates a BankerReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BankerReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BankerReq} BankerReq
         */
        BankerReq.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BankerReq)
                return object;
            var message = new $root.YXXGame.BankerReq();
            if (object.type != null)
                message.type = object.type | 0;
            return message;
        };

        /**
         * Creates a plain object from a BankerReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BankerReq
         * @static
         * @param {YXXGame.BankerReq} message BankerReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.type = 0;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this BankerReq to JSON.
         * @function toJSON
         * @memberof YXXGame.BankerReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerReq;
    })();

    YXXGame.BankerRsp = (function() {

        /**
         * Properties of a BankerRsp.
         * @memberof YXXGame
         * @interface IBankerRsp
         * @property {number} errorCode BankerRsp errorCode
         * @property {string|null} [errorInfo] BankerRsp errorInfo
         */

        /**
         * Constructs a new BankerRsp.
         * @memberof YXXGame
         * @classdesc Represents a BankerRsp.
         * @implements IBankerRsp
         * @constructor
         * @param {YXXGame.IBankerRsp=} [properties] Properties to set
         */
        function BankerRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerRsp errorCode.
         * @member {number} errorCode
         * @memberof YXXGame.BankerRsp
         * @instance
         */
        BankerRsp.prototype.errorCode = 0;

        /**
         * BankerRsp errorInfo.
         * @member {string} errorInfo
         * @memberof YXXGame.BankerRsp
         * @instance
         */
        BankerRsp.prototype.errorInfo = "";

        /**
         * Creates a new BankerRsp instance using the specified properties.
         * @function create
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {YXXGame.IBankerRsp=} [properties] Properties to set
         * @returns {YXXGame.BankerRsp} BankerRsp instance
         */
        BankerRsp.create = function create(properties) {
            return new BankerRsp(properties);
        };

        /**
         * Encodes the specified BankerRsp message. Does not implicitly {@link YXXGame.BankerRsp.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {YXXGame.IBankerRsp} message BankerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorCode);
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorInfo);
            return writer;
        };

        /**
         * Encodes the specified BankerRsp message, length delimited. Does not implicitly {@link YXXGame.BankerRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {YXXGame.IBankerRsp} message BankerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerRsp message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BankerRsp} BankerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BankerRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errorCode = reader.int32();
                    break;
                case 2:
                    message.errorInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errorCode"))
                throw $util.ProtocolError("missing required 'errorCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a BankerRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BankerRsp} BankerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerRsp message.
         * @function verify
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errorCode))
                return "errorCode: integer expected";
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                if (!$util.isString(message.errorInfo))
                    return "errorInfo: string expected";
            return null;
        };

        /**
         * Creates a BankerRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BankerRsp} BankerRsp
         */
        BankerRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BankerRsp)
                return object;
            var message = new $root.YXXGame.BankerRsp();
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            if (object.errorInfo != null)
                message.errorInfo = String(object.errorInfo);
            return message;
        };

        /**
         * Creates a plain object from a BankerRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BankerRsp
         * @static
         * @param {YXXGame.BankerRsp} message BankerRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errorCode = 0;
                object.errorInfo = "";
            }
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            if (message.errorInfo != null && message.hasOwnProperty("errorInfo"))
                object.errorInfo = message.errorInfo;
            return object;
        };

        /**
         * Converts this BankerRsp to JSON.
         * @function toJSON
         * @memberof YXXGame.BankerRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerRsp;
    })();

    YXXGame.Banker = (function() {

        /**
         * Properties of a Banker.
         * @memberof YXXGame
         * @interface IBanker
         * @property {string} id Banker id
         * @property {number} round Banker round
         * @property {string} balance Banker balance
         * @property {string|null} [userData] Banker userData
         * @property {number|null} [type] Banker type
         */

        /**
         * Constructs a new Banker.
         * @memberof YXXGame
         * @classdesc Represents a Banker.
         * @implements IBanker
         * @constructor
         * @param {YXXGame.IBanker=} [properties] Properties to set
         */
        function Banker(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Banker id.
         * @member {string} id
         * @memberof YXXGame.Banker
         * @instance
         */
        Banker.prototype.id = "";

        /**
         * Banker round.
         * @member {number} round
         * @memberof YXXGame.Banker
         * @instance
         */
        Banker.prototype.round = 0;

        /**
         * Banker balance.
         * @member {string} balance
         * @memberof YXXGame.Banker
         * @instance
         */
        Banker.prototype.balance = "";

        /**
         * Banker userData.
         * @member {string} userData
         * @memberof YXXGame.Banker
         * @instance
         */
        Banker.prototype.userData = "";

        /**
         * Banker type.
         * @member {number} type
         * @memberof YXXGame.Banker
         * @instance
         */
        Banker.prototype.type = 0;

        /**
         * Creates a new Banker instance using the specified properties.
         * @function create
         * @memberof YXXGame.Banker
         * @static
         * @param {YXXGame.IBanker=} [properties] Properties to set
         * @returns {YXXGame.Banker} Banker instance
         */
        Banker.create = function create(properties) {
            return new Banker(properties);
        };

        /**
         * Encodes the specified Banker message. Does not implicitly {@link YXXGame.Banker.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.Banker
         * @static
         * @param {YXXGame.IBanker} message Banker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Banker.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.round);
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.balance);
            if (message.userData != null && message.hasOwnProperty("userData"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.userData);
            if (message.type != null && message.hasOwnProperty("type"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
            return writer;
        };

        /**
         * Encodes the specified Banker message, length delimited. Does not implicitly {@link YXXGame.Banker.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.Banker
         * @static
         * @param {YXXGame.IBanker} message Banker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Banker.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Banker message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.Banker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.Banker} Banker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Banker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.Banker();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.balance = reader.string();
                    break;
                case 4:
                    message.userData = reader.string();
                    break;
                case 5:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("id"))
                throw $util.ProtocolError("missing required 'id'", { instance: message });
            if (!message.hasOwnProperty("round"))
                throw $util.ProtocolError("missing required 'round'", { instance: message });
            if (!message.hasOwnProperty("balance"))
                throw $util.ProtocolError("missing required 'balance'", { instance: message });
            return message;
        };

        /**
         * Decodes a Banker message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.Banker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.Banker} Banker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Banker.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Banker message.
         * @function verify
         * @memberof YXXGame.Banker
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Banker.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.id))
                return "id: string expected";
            if (!$util.isInteger(message.round))
                return "round: integer expected";
            if (!$util.isString(message.balance))
                return "balance: string expected";
            if (message.userData != null && message.hasOwnProperty("userData"))
                if (!$util.isString(message.userData))
                    return "userData: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isInteger(message.type))
                    return "type: integer expected";
            return null;
        };

        /**
         * Creates a Banker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.Banker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.Banker} Banker
         */
        Banker.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.Banker)
                return object;
            var message = new $root.YXXGame.Banker();
            if (object.id != null)
                message.id = String(object.id);
            if (object.round != null)
                message.round = object.round | 0;
            if (object.balance != null)
                message.balance = String(object.balance);
            if (object.userData != null)
                message.userData = String(object.userData);
            if (object.type != null)
                message.type = object.type | 0;
            return message;
        };

        /**
         * Creates a plain object from a Banker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.Banker
         * @static
         * @param {YXXGame.Banker} message Banker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Banker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.round = 0;
                object.balance = "";
                object.userData = "";
                object.type = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.round != null && message.hasOwnProperty("round"))
                object.round = message.round;
            if (message.balance != null && message.hasOwnProperty("balance"))
                object.balance = message.balance;
            if (message.userData != null && message.hasOwnProperty("userData"))
                object.userData = message.userData;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this Banker to JSON.
         * @function toJSON
         * @memberof YXXGame.Banker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Banker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Banker;
    })();

    YXXGame.BankerInfo = (function() {

        /**
         * Properties of a BankerInfo.
         * @memberof YXXGame
         * @interface IBankerInfo
         * @property {boolean} isPlayer BankerInfo isPlayer
         * @property {YXXGame.IBanker|null} [banker] BankerInfo banker
         * @property {string|null} [winLoss] BankerInfo winLoss
         */

        /**
         * Constructs a new BankerInfo.
         * @memberof YXXGame
         * @classdesc Represents a BankerInfo.
         * @implements IBankerInfo
         * @constructor
         * @param {YXXGame.IBankerInfo=} [properties] Properties to set
         */
        function BankerInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerInfo isPlayer.
         * @member {boolean} isPlayer
         * @memberof YXXGame.BankerInfo
         * @instance
         */
        BankerInfo.prototype.isPlayer = false;

        /**
         * BankerInfo banker.
         * @member {YXXGame.IBanker|null|undefined} banker
         * @memberof YXXGame.BankerInfo
         * @instance
         */
        BankerInfo.prototype.banker = null;

        /**
         * BankerInfo winLoss.
         * @member {string} winLoss
         * @memberof YXXGame.BankerInfo
         * @instance
         */
        BankerInfo.prototype.winLoss = "";

        /**
         * Creates a new BankerInfo instance using the specified properties.
         * @function create
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {YXXGame.IBankerInfo=} [properties] Properties to set
         * @returns {YXXGame.BankerInfo} BankerInfo instance
         */
        BankerInfo.create = function create(properties) {
            return new BankerInfo(properties);
        };

        /**
         * Encodes the specified BankerInfo message. Does not implicitly {@link YXXGame.BankerInfo.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {YXXGame.IBankerInfo} message BankerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isPlayer);
            if (message.banker != null && message.hasOwnProperty("banker"))
                $root.YXXGame.Banker.encode(message.banker, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.winLoss != null && message.hasOwnProperty("winLoss"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.winLoss);
            return writer;
        };

        /**
         * Encodes the specified BankerInfo message, length delimited. Does not implicitly {@link YXXGame.BankerInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {YXXGame.IBankerInfo} message BankerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerInfo message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BankerInfo} BankerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BankerInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isPlayer = reader.bool();
                    break;
                case 2:
                    message.banker = $root.YXXGame.Banker.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.winLoss = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("isPlayer"))
                throw $util.ProtocolError("missing required 'isPlayer'", { instance: message });
            return message;
        };

        /**
         * Decodes a BankerInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BankerInfo} BankerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerInfo message.
         * @function verify
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.isPlayer !== "boolean")
                return "isPlayer: boolean expected";
            if (message.banker != null && message.hasOwnProperty("banker")) {
                var error = $root.YXXGame.Banker.verify(message.banker);
                if (error)
                    return "banker." + error;
            }
            if (message.winLoss != null && message.hasOwnProperty("winLoss"))
                if (!$util.isString(message.winLoss))
                    return "winLoss: string expected";
            return null;
        };

        /**
         * Creates a BankerInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BankerInfo} BankerInfo
         */
        BankerInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BankerInfo)
                return object;
            var message = new $root.YXXGame.BankerInfo();
            if (object.isPlayer != null)
                message.isPlayer = Boolean(object.isPlayer);
            if (object.banker != null) {
                if (typeof object.banker !== "object")
                    throw TypeError(".YXXGame.BankerInfo.banker: object expected");
                message.banker = $root.YXXGame.Banker.fromObject(object.banker);
            }
            if (object.winLoss != null)
                message.winLoss = String(object.winLoss);
            return message;
        };

        /**
         * Creates a plain object from a BankerInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BankerInfo
         * @static
         * @param {YXXGame.BankerInfo} message BankerInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.isPlayer = false;
                object.banker = null;
                object.winLoss = "";
            }
            if (message.isPlayer != null && message.hasOwnProperty("isPlayer"))
                object.isPlayer = message.isPlayer;
            if (message.banker != null && message.hasOwnProperty("banker"))
                object.banker = $root.YXXGame.Banker.toObject(message.banker, options);
            if (message.winLoss != null && message.hasOwnProperty("winLoss"))
                object.winLoss = message.winLoss;
            return object;
        };

        /**
         * Converts this BankerInfo to JSON.
         * @function toJSON
         * @memberof YXXGame.BankerInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerInfo;
    })();

    YXXGame.BankerList = (function() {

        /**
         * Properties of a BankerList.
         * @memberof YXXGame
         * @interface IBankerList
         * @property {Array.<YXXGame.IBanker>|null} [bankers] BankerList bankers
         */

        /**
         * Constructs a new BankerList.
         * @memberof YXXGame
         * @classdesc Represents a BankerList.
         * @implements IBankerList
         * @constructor
         * @param {YXXGame.IBankerList=} [properties] Properties to set
         */
        function BankerList(properties) {
            this.bankers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankerList bankers.
         * @member {Array.<YXXGame.IBanker>} bankers
         * @memberof YXXGame.BankerList
         * @instance
         */
        BankerList.prototype.bankers = $util.emptyArray;

        /**
         * Creates a new BankerList instance using the specified properties.
         * @function create
         * @memberof YXXGame.BankerList
         * @static
         * @param {YXXGame.IBankerList=} [properties] Properties to set
         * @returns {YXXGame.BankerList} BankerList instance
         */
        BankerList.create = function create(properties) {
            return new BankerList(properties);
        };

        /**
         * Encodes the specified BankerList message. Does not implicitly {@link YXXGame.BankerList.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.BankerList
         * @static
         * @param {YXXGame.IBankerList} message BankerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.bankers != null && message.bankers.length)
                for (var i = 0; i < message.bankers.length; ++i)
                    $root.YXXGame.Banker.encode(message.bankers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BankerList message, length delimited. Does not implicitly {@link YXXGame.BankerList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.BankerList
         * @static
         * @param {YXXGame.IBankerList} message BankerList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankerList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankerList message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.BankerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.BankerList} BankerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.BankerList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.bankers && message.bankers.length))
                        message.bankers = [];
                    message.bankers.push($root.YXXGame.Banker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BankerList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.BankerList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.BankerList} BankerList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankerList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankerList message.
         * @function verify
         * @memberof YXXGame.BankerList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankerList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.bankers != null && message.hasOwnProperty("bankers")) {
                if (!Array.isArray(message.bankers))
                    return "bankers: array expected";
                for (var i = 0; i < message.bankers.length; ++i) {
                    var error = $root.YXXGame.Banker.verify(message.bankers[i]);
                    if (error)
                        return "bankers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BankerList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.BankerList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.BankerList} BankerList
         */
        BankerList.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.BankerList)
                return object;
            var message = new $root.YXXGame.BankerList();
            if (object.bankers) {
                if (!Array.isArray(object.bankers))
                    throw TypeError(".YXXGame.BankerList.bankers: array expected");
                message.bankers = [];
                for (var i = 0; i < object.bankers.length; ++i) {
                    if (typeof object.bankers[i] !== "object")
                        throw TypeError(".YXXGame.BankerList.bankers: object expected");
                    message.bankers[i] = $root.YXXGame.Banker.fromObject(object.bankers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BankerList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.BankerList
         * @static
         * @param {YXXGame.BankerList} message BankerList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankerList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.bankers = [];
            if (message.bankers && message.bankers.length) {
                object.bankers = [];
                for (var j = 0; j < message.bankers.length; ++j)
                    object.bankers[j] = $root.YXXGame.Banker.toObject(message.bankers[j], options);
            }
            return object;
        };

        /**
         * Converts this BankerList to JSON.
         * @function toJSON
         * @memberof YXXGame.BankerList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankerList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BankerList;
    })();

    YXXGame.RechargeNotify = (function() {

        /**
         * Properties of a RechargeNotify.
         * @memberof YXXGame
         * @interface IRechargeNotify
         */

        /**
         * Constructs a new RechargeNotify.
         * @memberof YXXGame
         * @classdesc Represents a RechargeNotify.
         * @implements IRechargeNotify
         * @constructor
         * @param {YXXGame.IRechargeNotify=} [properties] Properties to set
         */
        function RechargeNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RechargeNotify instance using the specified properties.
         * @function create
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {YXXGame.IRechargeNotify=} [properties] Properties to set
         * @returns {YXXGame.RechargeNotify} RechargeNotify instance
         */
        RechargeNotify.create = function create(properties) {
            return new RechargeNotify(properties);
        };

        /**
         * Encodes the specified RechargeNotify message. Does not implicitly {@link YXXGame.RechargeNotify.verify|verify} messages.
         * @function encode
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {YXXGame.IRechargeNotify} message RechargeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified RechargeNotify message, length delimited. Does not implicitly {@link YXXGame.RechargeNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {YXXGame.IRechargeNotify} message RechargeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RechargeNotify message from the specified reader or buffer.
         * @function decode
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {YXXGame.RechargeNotify} RechargeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.YXXGame.RechargeNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RechargeNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {YXXGame.RechargeNotify} RechargeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RechargeNotify message.
         * @function verify
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RechargeNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a RechargeNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {YXXGame.RechargeNotify} RechargeNotify
         */
        RechargeNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.YXXGame.RechargeNotify)
                return object;
            return new $root.YXXGame.RechargeNotify();
        };

        /**
         * Creates a plain object from a RechargeNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof YXXGame.RechargeNotify
         * @static
         * @param {YXXGame.RechargeNotify} message RechargeNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RechargeNotify.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RechargeNotify to JSON.
         * @function toJSON
         * @memberof YXXGame.RechargeNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RechargeNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RechargeNotify;
    })();

    return YXXGame;
})();

module.exports = $root;
